import Vue from 'vue';

// eslint-disable-next-line
export const Bus = new Vue();
